/* eslint-disable no-param-reassign */
import React, { createContext } from 'react'
import { graphql } from 'gatsby'

// Components
import SEO from 'components/shared/SEO'
import LcpPreload from 'components/shared/LcpPreload'
import Layout from 'components/layout/Layout'
import FlexContentHandler from 'components/shared/FlexContentHandler'

export const PostContext = createContext({
  title: '',
  image: null,
})

interface PageTemplateProps {
  data: {
    page: {
      path?: string
      title?: string
      seo: any
      recap: any
      flexContent: any
    }
  }
  location?: any
  prefix?: string
}

const PageTemplate: React.FC<PageTemplateProps> = ({
  data: {
    page: { title, recap, flexContent, seo },
  },
  location = {},
  prefix = 'post_Flexcontent',
}) => {
  // add article schema and breadcrumb list schema
  if (seo) {
    seo.schema = [
      {
        '@context': 'https://schema.org',
        '@type': 'NewsArticle',
        mainEntityOfPage: {
          '@type': 'WebPage',
          '@id': location.href,
        },
        headline: title,
        image: [
          `${location.origin}${recap?.image?.localFile?.childImageSharp.gatsbyImageData.images.fallback.src}` ||
            '',
        ],
        datePublished: recap?.dateGmt,
        dateModified: recap?.modifiedGmt,
        author: {
          '@type': 'Person',
          name: 'Jan de Graaf',
          url: 'https://www.perfectfirecontrol.nl/over-ons/',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'Home',
            item: location.origin,
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: 'Blog',
            item: `${location.origin}/blog`,
          },
          {
            '@type': 'ListItem',
            position: 3,
            name: title,
            item: location.href,
          },
        ],
      },
    ]
  }

  return (
    <Layout>
      <SEO seo={seo} />
      <LcpPreload flexContent={flexContent} />
      <PostContext.Provider
        value={{
          title,
          image: recap.image,
        }}
      >
        <FlexContentHandler
          prefix={prefix}
          fields={flexContent}
          location={location}
        />
      </PostContext.Provider>
    </Layout>
  )
}

export const pageQuery = graphql`
  query postById($pageId: String!) {
    page: wpPost(id: { eq: $pageId }) {
      ...generalPostFragment
    }
  }
`

export default PageTemplate
